import { useApolloClient } from "@apollo/client";
import toast from "src/swsh-native/toast";
import { useEffect, useState } from "react";
import useStateRef from "src/hooks/useStateRef";
import { useInsideModal } from "src/modals";
import InternalModal from "src/modals/configs/InternalModal";

const useShareableResolvedProps = () => {
	const {
		props: {
			shareable: { getProps, initialProps },
		},
	} = useInsideModal<InternalModal["Shareable"]>();

	const [resolvedProps, setResolvedProps, resolvedPropsRef] = useStateRef<Awaited<
		ReturnType<typeof getProps>
	> | null>(null);
	const apolloClient = useApolloClient();
	const [initialPropsPromise] = useState(
		() =>
			initialProps ??
			getProps({
				apolloClient,
			}),
	);
	useEffect(() => {
		initialPropsPromise.then((res) => {
			if (resolvedPropsRef.current) return;
			if (res) {
				setResolvedProps(res);
			}
			if (!res || (res.success === false && !res.ErrorComponent)) {
				toast({
					preset: "error",
					title: "Error loading preview",
					message: "Please try again later",
				});
			}
		});
	}, [initialPropsPromise, resolvedPropsRef, setResolvedProps]);

	return { resolvedProps };
};

export type ShareableResolvedProps = ReturnType<typeof useShareableResolvedProps>["resolvedProps"];

export default useShareableResolvedProps;
